export default "__VITE_ASSET__DpaWYbJg__"